export default __webpack_public_path__ + "static/media/1325.65404012.png";